import classNames from "classnames";

export const FeatureSection = ({
  section,
}: {
  section: Travelguide.AccomodationSection.Feature;
}) => {
  return (
    <section className="flex flex-col gap-5 px-4 md:px-6">
      <header>
        <h2>Ausstattung</h2>
      </header>
      <main
        className={classNames(
          "flex flex-col md:grid md:grid-cols-2 gap-10 gap-y-6",
          "lg:grid-cols-[repeat(auto-fit,minmax(calc(100%/3-(2.5rem*2/3)),1fr))]"
        )}
      >
        {section.value.map(({ title, features }, i) => (
          <div key={i} className="flex flex-col gap-2">
            <h3>{title}</h3>
            {features.join(", ")}
          </div>
        ))}
      </main>
    </section>
  );
};
